import { slicedToArray as _slicedToArray, defineProperty as _defineProperty, toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { Select } from '@deal/components';
import { usePathContext } from '../../../../context/PathContext.js';
import classNames from 'classnames';
import styles from './styles.css.js';

var DropDown = function DropDown(_ref) {
  var question = _ref.question,
      loading = _ref.loading,
      onQuestionUpdated = _ref.onQuestionUpdated,
      onQuestionValidityChanged = _ref.onQuestionValidityChanged;

  var _a;

  var pathContext = usePathContext();
  var listQuestion = question;
  var initialSelectedChoice = ((_a = listQuestion.choices.find(function (choice) {
    return choice.selected;
  })) === null || _a === void 0 ? void 0 : _a.id) || '';

  var _useState = useState(initialSelectedChoice),
      _useState2 = _slicedToArray(_useState, 2),
      selectedChoice = _useState2[0],
      setSelectedChoice = _useState2[1];

  var populateListQuestion = function populateListQuestion(selectedChoice) {
    var _a;

    setSelectedChoice(selectedChoice);
    onQuestionUpdated({
      id: (_a = pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.id,
      listQuestion: {
        questionId: question.id,
        values: selectedChoice ? [selectedChoice] : []
      }
    });
    onQuestionValidityChanged(question.commonFields.required ? !!selectedChoice : true);
  };

  useEffect(function () {
    if (initialSelectedChoice) {
      populateListQuestion(initialSelectedChoice);
    }
  }, []);
  return React.createElement("div", {
    className: classNames(styles.container, _defineProperty({}, styles.placementModal, pathContext.pathPlacement === 'modal')),
    "data-testid": "path-dropdown-container"
  }, React.createElement(Select, {
    disabled: loading,
    label: "",
    labelHidden: true,
    name: question.id,
    defaultValue: selectedChoice,
    onChange: function onChange(ev) {
      populateListQuestion(ev.target.value);
    },
    options: [{
      value: '',
      label: 'Please select one...',
      disabled: true
    }].concat(_toConsumableArray(listQuestion.choices.map(function (choice) {
      return {
        label: choice.text ? choice.text.plainText : '',
        value: choice.id,
        disabled: false
      };
    })))
  }));
};

export default DropDown;
//# sourceMappingURL=index.js.map
